import { createApplier } from '@/app/libs/I';
import { errorRuntime } from '@/shared/lib/core/errors';
import { Request } from '@/app/modules/request/Request';

/**
 * @deprecated legacy
 */
export namespace requestService {
  /**
   * @deprecated legacy
   */
  export const applierId = Symbol('request-service');
  /**
   * @deprecated legacy
   */
  export const apply = createApplier(applierId);

  /**
   * @deprecated legacy
   */
  export async function applyWithBitrixHandler<T extends any>(model: Request): Promise<T> {
    try {
      return await apply(model) as T;
    } catch (e: any) {
      if (e.response?.data?.error) {
        errorRuntime(e.response.data.error);
      } else {
        throw e;
      }
    }
  }
}
